var _desc, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandwich(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sandwich") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 22.5L2 46l8 4m4 6a6 6 0 0 0 11.6 2.2 5 5 0 0 0 9.3-1.2 6 6 0 0 0 10.8-1M54 26.2a10 10 0 0 1 0 19.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M32 2C19.4 2 2 3.9 2 14s8 8.5 8 8.5V51a5 5 0 0 0 5 5h34a5 5 0 0 0 5-5V22.4s8-.3 8-8.4S54.3 2 32 2z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 19,
    cy: 15,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 27,
    cy: 27,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 44,
    cy: 20,
    r: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 42,
    cy: 38,
    r: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 25,
    cy: 45,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandwich);
export default __webpack_public_path__ + "static/media/sandwich.42ac1abd.svg";
export { ForwardRef as ReactComponent };